import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { Jackpot, jackpotSchema, createPaginatedSchema } from '../types';

export type OriginalJackpotRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	currencies?: string[];
	gameIds?: string[];
	accountIds?: string[];
};

export type JackpotRegistryFilters = {
	currencies: string[];
	gameIds: number[];
	accountIds: number[];
};

export type JackpotRegistryParams = RegistryParams<JackpotRegistryFilters>;

export type JackpotRegistryQuery = RegistryQuery<
	Jackpot,
	JackpotRegistryFilters,
	JsonApiRequestError
>;

export const createJackpotRegistryQuery = (
	$accountId?: Store<number | null>,
): JackpotRegistryQuery => {
	const query = createAuthQuery({
		params: declareParams<JackpotRegistryParams>(),
		request: {
			method: 'GET',
			url: '/jackpot/list',
			query: {
				source: $accountId ?? createStore(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					currencies:
						params.filters.currencies?.length === 0 ? undefined : params.filters.currencies,
					gameIds:
						params.filters.gameIds?.length === 0 ? undefined : params.filters.gameIds.map(String),
					accountIds: [
						...(accountId ? [String(accountId)] : []),
						...params.filters.accountIds.map(String),
					],
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(jackpotSchema)),
		},
	});

	return query;
};
